// View Keys 
export default {
  reportTypesModal_title: 'Tipos de informes'
};